
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";

const FooterMenu = (props) => {
    const { playerMenu } = useSelector((state) => ({
        playerMenu: state.menuListR.data
    }));
    const [loggedIn, setLoggedIn] = useState('');
    const [footerMenu, setFooterMenu] = useState([]);
    let token = window.localStorage.getItem("user_token");
    useEffect(() => {
        setLoggedIn(token);
    }, [token]);
    useEffect(() => {
        if (playerMenu)
            if (!loggedIn) {
                setFooterMenu(playerMenu['before']);
            } else {
                setFooterMenu(playerMenu["after"]);
            }

    }, [loggedIn, playerMenu])

    return (
        <>
            <div className="content">
                <h2 className="title hot-new-game-wrapper text-footer_heading">{props.t('info')}</h2>
                <div className="info">
                    <navbar>
                        <ul>
                            {Object.values(footerMenu).map((v, i) => {
                                return (v?.footer_menu && v?.status && v?.code != 'live-chat') &&
                                    <li key={v?.code}>
                                        <Link to={"/" + v?.code}>
                                            {props.t(`${v?.name.toLowerCase().replace(/ /g, '_')}`)}
                                        </Link>
                                    </li>
                            })}
                        </ul>
                    </navbar>
                </div>
            </div>
        </>
    );
};

export default withTranslation()(FooterMenu);